import apiClient from '../index';
import type { FileRowFilters, FileRowsQuery } from '../../schemas';

/** `/files/:fileId` on intake, `/audits/:auditId/files/:fileId` on the audit side. */
export function fileRowsBase(fileId: string, auditId?: string | null): string {
	return auditId ? `/audits/${auditId}/files/${fileId}` : `/files/${fileId}`;
}

/** Drops empty values so the request only names what is actually asked for. */
function clean<T extends object>(params: T): Record<string, string | number> {
	return Object.fromEntries(
		Object.entries(params).filter(
			([, value]) => value !== undefined && value !== '',
		),
	) as Record<string, string | number>;
}

export const getRowsSummary = async (base: string) => {
	const response = await apiClient.get(`${base}/rows/summary`);
	return response.data;
};

export const getRowsPage = async (base: string, query: FileRowsQuery) => {
	const response = await apiClient.get(`${base}/rows`, {
		params: clean(query),
	});
	return response.data;
};

export const getRowValues = async (
	base: string,
	query: FileRowFilters & { column: string; limit?: number },
) => {
	const response = await apiClient.get(`${base}/rows/values`, {
		params: clean(query),
	});
	return response.data;
};

export const exportRows = async (
	base: string,
	body: FileRowFilters & { sort?: string; dir?: 'asc' | 'desc' },
) => {
	const response = await apiClient.post(`${base}/rows/export`, clean(body));
	return response.data;
};
